'use strict';

/**
 * @classname CurrentViewedItem
 * @classdesc 最近見た商品
 */
export default class CurrentViewedItem {
	/**
	 * @constructor
	 * @param {jQuery} $e - .swiper--current-viewed
	 * @param {instance} controller - controller instance
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		let items = localStorage.getItem('viewed_items') || null;
		if(items) {
			items = JSON.parse(items);
			if(items.length === 0){
				$('.swiper--current-viewed').closest('.section--bottom-slider').remove();
				return;
			}
			for(let i = 0; i < items.length; i++){
				this.createItemCard(items[i]);
			}
			if(items.length > 2){
				controller.setSwiper();
			} else {
				$('.swiper--current-viewed').addClass('no-slide');
			}
		}else{
			$('.swiper--current-viewed').closest('.section--bottom-slider').remove();
		}
	};


	/**
	 * changeのコールバック
	 *
	 * @memberof CurrentViewedItem
	 * @param {json} item - 商品データ
	 * @return undefined
	 */
	createItemCard(item) {
		console.log(`${this.constructor.name}.createItemCard`);
		let price;
		if (item.price && item.price !== '') {
			if(item.price.match(/\./)){
				item.price = item.price.replace(/\.<span class="decimal">00<\/span>/, '');
				price = `<strong>${item.price}</strong>（税込）`;
			}else{
				price = `<strong>${item.price}</strong>（税込）`;
			}
		}else{
			price = `<strong>&nbsp;</strong>`;
		}
		const card =
`<div class="swiper-slide">
	<div class="card card--item">
		<div class="card__header">
			<a class="anchor" href="/items/${item.id}">
				<img class="image" src="${item.photoUrl}" alt="${item.name}">
			</a>
		</div>
		<div class="card__body">
			<a class="anchor anchor--item-name" href="/items/${item.id}">${item.name}</a>
			<div class="block block--item-price">
				${price}
			</div>
		</div>
	</div>
</div>`;
		$('.swiper--current-viewed .swiper-wrapper').append(card);
	};
};
